 
<div class="popover" [ngClass]="context === 'triage' ? 'triage-popover' : 'backlog-popover'">  
    <div class="popover-content row">
        <div class="col-md-6">
            <!-- Libellés disponibles -->
            <div class="assignee-group">
                <div class="assignee-group-title">{{'backlog.task_details.assign' | translate}}</div>
                <div class="assignee-list">
                    @for(assignee of managers; track assignee.id){
                        <div class="assignee-item w-100" [ngClass]="setSelectedAssigneeClass(assignee)">
                            <div class="d-flex align-items-center" (click)="toggleAssignee(assignee)">
                                <div>
                                <i class="fa-regular fa-square pe-2"></i>
                                <i class="fa-regular fa-square-check pe-2"></i>
                                </div>
                                <div>
                                {{ assignee.firstname }} {{ assignee.lastname }}
                                </div>
                            </div>
                        </div>
                        }
                </div> 
            </div>
        </div>
        <div class="col-md-6">
            <!-- Libellés disponibles -->
            <div class="label-group">
                <div class="label-group-title">{{'task_label.popover.label' | translate}}</div>
                <div class="label-list" [ngClass]="{'long-list': filteredLabels.length > 5}">
                    @for(label of filteredLabels; track label.id){
                        <div class="label-item" [ngClass]="setSelectedClass(label)">
                            <div class="d-flex align-items-center" (click)="toggleLabel(label)">
                            <div>
                                <i class="fa-regular fa-square pe-2"></i>
                                <i class="fa-regular fa-square-check pe-2"></i>
                            </div>
                            <div>
                                {{ label.name }}
                                <span class="ps-2 label-color" [style.background-color]="label.color"></span>
                            </div>
                            </div>
                            <!-- <div class="text-secondary">
                                <span (click)="editLabel(label)" class="pe-2">
                                    <i class="fa-regular fa-pen-to-square"></i>
                                </span>
                                <span (click)="deleteLabel(label)">
                                    <i class="fa-regular fa-xmark"></i>
                                </span>
                            </div> -->
                        
                        </div>
                    }
                </div>
                <div>
                    <button class="btn btn-add-label" (click)="addLabel()" [disabled]="availableLabels.map(label => label.name).indexOf(searchCtrl.getRawValue()) !== -1">{{ 'task_label.popover.new' | translate }}</button>
                </div>
            </div>
        </div>
    </div>
      <div class="popover-footer">
          <button class="btn w-100 btn-primary" (click)="applyAssigneeAndLabels(selectedAssignees, selectedLabels)">{{ 'task_label_and_assignee.popover.apply' | translate}}</button>
      </div>
</div>
   